var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-cabinet',{attrs:{"online-mode":true}},[_c('template',{slot:"content"},[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }